import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";

import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import UslugePage from "@/pages/UslugePage";
import UslugaDetailPage from "@/pages/UslugaDetailPage";
import KontaktPage from "@/pages/KontaktPage";
import LegalizacijaPage from "@/pages/LegalizacijaPage";
import PostupakPage from "@/pages/PostupakPage";
import ONamaPage from "@/pages/ONamaPage";
import PropisiPage from "@/pages/PropisiPage";
import PrijavaPage from "@/pages/PrijavaPage";
import AdminPage from "@/pages/AdminPage";
import NotFoundPage from "@/pages/NotFoundPage";

function App() {
  return (
    <HelmetProvider>
    <div className="App bg-background text-ink">
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/usluge" element={<UslugePage />} />
            <Route path="/usluge/:slug" element={<UslugaDetailPage />} />
            <Route path="/kontakt" element={<KontaktPage />} />
            <Route path="/legalizacija" element={<LegalizacijaPage />} />
            <Route path="/postupak-legalizacije" element={<PostupakPage />} />
            <Route path="/o-nama" element={<ONamaPage />} />
            <Route path="/zakonski-propisi" element={<PropisiPage />} />
            <Route path="/prijava" element={<PrijavaPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
    </HelmetProvider>
  );
}

export default App;
